import Card from '@Utils/Card';
import { Button, Form, Input } from 'antd';
import React from 'react';
import styles from './createTelegramBot.module.less';
import { showMessageError } from '@Utils/RenderUtils';

function CreateTelegramBot(props) {
  const [form] = Form.useForm();

  return (
    <Card>
      <Form
        style={{ width: '100%', maxWidth: '100%' }}
        form={form}
        onFieldsChange={([data]) => {
          const [name] = data.name;

          props.telegramChannelChangeCurrent(data.value, name);
        }}
        onFinish={async (values) => {
          try {
            await form.validateFields();

            if (values)
              props.telegramChannelCreateFetch(values, () => {
                form.resetFields();
              });
          } catch (err) {
            showMessageError(err);
          }
        }}
      >
        <div className={styles.title}>
          <span>Create Telegram Bot</span>
        </div>
        <div className={styles.content}>
          <div className={styles.input}>
            <Form.Item
              rules={[{ required: true, message: 'name field is required' }]}
              requiredMark="optional"
              label="NAME"
              name="name"
              htmlFor="name"
              labelCol={{ style: { width: 85 } }}
            >
              <Input name="name" value={props.name} style={{ width: 300 }} />
            </Form.Item>
          </div>
          <div className={styles.input}>
            <Form.Item
              rules={[
                { required: true, message: 'token field is required' },
                {
                  pattern: /^[0-9]{8,10}:[a-zA-Z0-9_-]{35}$/,
                  message: 'token is invalid',
                },
              ]}
              requiredMark="optional"
              label="BOT TOKEN"
              name="botToken"
              htmlFor="botToken"
              labelCol={{ style: { width: 85 } }}
            >
              <Input
                name="botToken"
                autoCorrect="off"
                autoComplete="off"
                value={props.botToken}
                style={{ width: 300 }}
              />
            </Form.Item>
          </div>
          <div className={styles.input}>
            <Form.Item
              label="BATCH SIZE"
              name="batchSize"
              htmlFor="batchSize"
              rules={[
                { pattern: /\d+/, message: 'batch size must be an integer' },
              ]}
              labelCol={{ style: { width: 85 } }}
            >
              <Input
                name="batchSize"
                value={props.batchSize}
                style={{ width: 300 }}
              />
            </Form.Item>
          </div>
          <div className={styles.actions}>
            <Button loading={props.creating} htmlType="submit" type="primary">
              SAVE
            </Button>
          </div>
        </div>
      </Form>
    </Card>
  );
}

export default CreateTelegramBot;
